import { z } from "zod";
import { dmaCalculationResultDtoSchema } from "./dma-calculation-result.schema";
export const dmaCalculationResultsDtoSchema = z.object({
    results: z.array(dmaCalculationResultDtoSchema),
});
